import {
  LitheElement,
  LitheFC,
  redrawFragment,
} from '@wheelbox/lithejs-engine';
import { withRouteParams } from '@wheelbox/lithejs-router';

import withPageTitle from '@lib/page';
import { apiFetch } from '@lib/api';
import LitheDocs from '@lib/lithe-docs';
import { LitheDocsObject } from '@lib/lithe-docs/types';

import LoadingIndicator from '@components/layout/loading-indicator';
import { Card } from '@components/ui';

const PostPage: LitheFC = ({
  id = 'docs-page',
  testId = 'docs-page',
}): LitheElement<'main'> => {
  withPageTitle('LitheJS | Blog');
  const { slug } = withRouteParams();

  let post: LitheDocsObject | undefined;

  const onMountHandler = async () => {
    const response = await apiFetch(`/posts/${slug}.lithe`, {
      method: 'GET',
    });

    post = new LitheDocs(await response.text()).parse();

    redrawFragment(`${id}-content`);
  };

  return [
    'main',
    { id, 'data-testid': testId, onmount: onMountHandler },
    () => [
      'article',
      { id: `${id}-content` },
      ['h1', { class: 'text-primary mb-4' }, post ? post.title : '...'],
      post
        ? Card(
            {
              id: `${id}-content`,
              classes:
                '[&_p]:mb-2 [&_a]:text-primary [&_small_span:first-child]:text-primary',
            },
            ...post.content,
            [
              'small',
              ['span', post.author],
              ['span', ', '],
              ['span', new Date(post.created).toLocaleString()],
            ]
          )
        : LoadingIndicator({}),
    ],
  ];
};

export default PostPage;
